import { render, staticRenderFns } from "./rfp-manager-dropdown-actions.vue?vue&type=template&id=1572c647"
import script from "./rfp-manager-dropdown-actions.vue?vue&type=script&lang=js"
export * from "./rfp-manager-dropdown-actions.vue?vue&type=script&lang=js"
import style0 from "./rfp-manager-dropdown-actions.vue?vue&type=style&index=0&id=1572c647&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports